import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuditLog = () => {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 40;

  useEffect(() => {
    axios.get(`${API}/audit`, { params: { page, limit } }).then((res) => { setLogs(res.data.logs); setTotal(res.data.total); });
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <div data-testid="dash-audit-log">
      <div className="dash-panel">
        <div className="dash-panel__head"><h2>Audit Log ({total})</h2></div>
        {logs.length === 0 && <div className="empty-state">No audit events yet.</div>}
        {logs.map((l) => (
          <div className="audit-row" key={l.id} data-testid={`audit-row-${l.id}`}>
            <div className="audit-row__time">{new Date(l.timestamp).toLocaleString()}</div>
            <div className="audit-row__body">
              <b>{l.actor_email}</b> &mdash; {l.action.replace(/_/g, ' ')} {l.target ? <>on <b>{l.target}</b></> : ''}
              {l.details && Object.keys(l.details).length > 0 && (
                <div style={{ fontSize: '0.78rem', color: 'var(--text-dim)', marginTop: 2 }}>{JSON.stringify(l.details)}</div>
              )}
            </div>
          </div>
        ))}
        <div className="pagination">
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} data-testid="audit-page-prev">Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)} data-testid="audit-page-next">Next</button>
        </div>
      </div>
    </div>
  );
};

export default AuditLog;
